webpackJsonp([159510746486587],{

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _BaseChapter = __webpack_require__(18);
	
	var _BaseChapter2 = _interopRequireDefault(_BaseChapter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _BaseChapter2.default; /* global graphql */
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-chapters-black-hole-js-c1261ef88ad30a456fd7.js